import { BDropdown } from '../BDropdown/BDropdown'
import { useAppDispatch } from '../../../hooks/useAppDispatch'
import { showModal } from '../../../store/actions/modalActions'
import { ModalTypes } from '../../../types/modals'
import { faFileUpload } from '@fortawesome/free-solid-svg-icons/faFileUpload'
import { faFileDownload } from '@fortawesome/free-solid-svg-icons/faFileDownload'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { selectProductSystemActions } from '../../../store/selectors/systemActionsSelectors'
import { AppDropdownItem } from '../AppDropdown/AppDropdown'
import { faGear } from '@fortawesome/free-solid-svg-icons/faGear'
import { faEllipsis } from '@fortawesome/free-solid-svg-icons/faEllipsis'
import { Settings } from '../../CoreSettings/Settings'
import React from 'react'
import { User } from '../../../entity/User'
import { showActionsBar, showRightBar } from '../../../store/actions/rightBarActions'
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons/faClockRotateLeft'
import { ConfigChangeHistoryBar } from '../../ConfigChangeHistoryBar/ConfigChangeHistoryBar'

interface DropdownMoreProps {
    guid: string
    className?: string
}

export const DropdownMore = (props: DropdownMoreProps) => {
    const { guid, className } = props
    const dispatch = useAppDispatch()
    const authUser = new User()

    const productSystemActions =
        useAppSelector(selectProductSystemActions(guid)) ?? {}

    const {
        get_configuration_file: hasGetConfigFile,
        set_configuration_file: hasSetConfigFile,
        set_configuration_files: hasSetConfigFiles,
    } = productSystemActions

    const handleUploadConfig = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()

        const uploadConfigModalType = hasSetConfigFiles
            ? ModalTypes.UPLOAD_MULTIPLE_CONFIGS_MODAL
            : ModalTypes.UPLOAD_CONFIG_MODAL

        dispatch(
            showModal(uploadConfigModalType, {
                guid,
            })
        )
    }

    const handleDownloadConfig = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()
        dispatch(
            showModal(ModalTypes.CONFIGS_MODAL, {
                guid,
            })
        )
    }

    const handleOpenGeneralSettings = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()
        dispatch(
            showRightBar({
                rightBarItem: <Settings guid={guid} />,
                disableHide: false
            })
        )
    }

    const handleOpenConfigChangeHistory = (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation()
        dispatch(
            showActionsBar({
                rightBarItem: <ConfigChangeHistoryBar guid={guid} />,
            })
        )
    }

    const uploadConfig: AppDropdownItem = {
        name: hasSetConfigFiles ? 'buttons.uploadConfigs' : 'buttons.uploadConfig',
        icon: faFileUpload,
        action: handleUploadConfig,
        disabled: !hasSetConfigFile && !hasSetConfigFiles,
    }
    const downloadConfig: AppDropdownItem = {
        name: 'buttons.downloadConfig',
        icon: faFileDownload,
        action: handleDownloadConfig,
        disabled: !hasGetConfigFile,
    }
    const generalSettings: AppDropdownItem = {
        name: 'buttons.settings',
        icon: faGear,
        action: handleOpenGeneralSettings,
        disabled: authUser.isViewer(),
    }
    const configChangeHistory: AppDropdownItem = {
        name: 'buttons.configChangeHistory',
        icon: faClockRotateLeft,
        action: handleOpenConfigChangeHistory,
        disabled: !(authUser.isOwner() || authUser.isAdministrator())
    }

    const dropdownItems = authUser.isFullRightsManagerOrAbove()
        ? [uploadConfig, downloadConfig, generalSettings, configChangeHistory]
        : [generalSettings]


    return (
        <BDropdown
            hasHr={authUser.isFullRightsManagerOrAbove()}
            className={`rounded-blue-btn ${className}`}
            tooltip="More"
            dropdownItems={dropdownItems}
            icon={faEllipsis}
            isDisabled={false}
        />
    )
}
